export default __webpack_public_path__ + "static/media/logo-long-contrast.f29674e8.png";